import { ClientAssignmentReference } from 'components/pages/Property/ClientProperty/ClientAssignmentReference'
import { ClientGalleryActionsPanel } from '../ClientGalleryActionsPanel'
import { ClientGalleryFiltersDropdown } from '../ClientGalleryFiltersDropdown'
import { FC } from 'react'
import Stack from '@mui/material/Stack'

/**
 * Client gallery photo section Action Panel and Filters
 * 
 * @example <ClientGalleryPhotoSectionActionFilterPanels />
 */
export const ClientGalleryPhotoSectionActionFilterPanels: FC = () => {

  return (
    <Stack
      flexDirection={{ xs: 'column', md: 'row' }}
      justifyContent="flex-end"
      alignItems={{ xs: 'start', md: 'center' }}
      gap="1.5rem"
    >

      <ClientAssignmentReference />
      <ClientGalleryFiltersDropdown />
      <ClientGalleryActionsPanel />

    </Stack>
  )
}
